export default "__VITE_ASSET__DGexa7Nj__"